module.exports = "/static/fonts/Framework7Icons-Regular.988e8c7.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/framework7-icons/fonts/Framework7Icons-Regular.woff2
// module id = 804
// module chunks = 2